var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.workflow)?_c('incoming-invoice-home',{attrs:{"incomingInvoices":_vm.workflow.incomingInvoices}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }